import { Component, OnInit } from '@angular/core';
import { BackendService } from '../../service/backend.service';
import { UserService } from '../../service/user.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule, formatDate, NgForOf, UpperCasePipe } from '@angular/common';
import { CardService } from '../../service/card.service';
import { FormatMinutesPipe } from '../../pipes/format-minutes.pipe';
import { CdrsService } from '../../service/cdrs.service';

export interface MyCardData {
  iccid: string,
  msisdn: string,
  packagePlan: string,
  status?: string,
  minutesLeft: number,
  expiryDate: string,
}

export interface MyCardEventData {
  iccid: string,
  msisdn: string,
  packagePlan: string,
  eventDate: string,
  serviceType: string,
  destination: string,
  minutesUsed: number
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    NgForOf,
    UpperCasePipe,
    CommonModule,
    FormatMinutesPipe,
    RouterLink
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

  myCards: MyCardData[] = [];
  myArchivedCards: MyCardData[] = [];
  myCardsEvents: MyCardEventData[] = [];
  protected readonly formatDate = formatDate;

  constructor(
    private readonly backendService: BackendService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly cardService: CardService,
    private readonly cdrsService: CdrsService
  ) {
  }

  ngOnInit(): void {
    console.log('ActivatedRoute snapshot:', this.route.snapshot.url);
    console.log('Params:', this.route.snapshot.params);
    this.route.paramMap.subscribe(params => {
      console.log('ParamMap:', params);
    });
    // log stan zalogowania:
    console.log('Is user logged in:', this.userService.isUserLoggedIn());

    this.fetchUserCards();
    this.fetchUserCdrs();
  }

  async fetchUserCards(): Promise<void> {
    const cards = await this.cardService.getCardsByUser(this.getCurrentUserId());
    if (cards.activated && cards.activated.length > 0
    ) {
      this.myCards = cards.activated.map(card => {
        return {
          iccid: card.iccid,
          msisdn: card.msisdn,
          packagePlan: card.currentPricePlan?.name,
          minutesLeft: card.minutesLeft ?? 0,
          expiryDate: card.validUntil
        }
      });
    }
    if (cards.archived && cards.archived.length > 0) {
      this.myArchivedCards = cards.archived.map(card => {
        return {
          iccid: card.iccid,
          msisdn: card.msisdn,
          packagePlan: card.currentPricePlan?.name,
          minutesLeft: card.minutesLeft ?? 0,
          expiryDate: card.validUntil,
          status: card.status ?? 'expired'
        }
      });
    }
  }

  async fetchUserCdrs(): Promise<void> {
    const cdrs = await this.cdrsService.getAllCdrsByUser(this.getCurrentUserId());
    if (cdrs && cdrs.length > 0) {
      cdrs.forEach(cdr => {
        const event: MyCardEventData = {
          iccid: cdr.iccid,
          msisdn: cdr.msisdn,
          packagePlan: '',
          eventDate: cdr.cdrTimestamp,
          serviceType: cdr.service ?? '-',
          destination: cdr.destNumber ?? cdr.destNetwork ?? cdr.destCountry ?? '-',
          minutesUsed: cdr.usedMin ?? 0

        }
        this.myCardsEvents.push(event);
      })
    }
  }

  async orderBilling() {
    await this.cardService.orderBilling("");
  }

  private getCurrentUserId() {
    return this.userService.getUserLoggedIn()?.userId || '-no-user-id-';
  }
}
